import { Injectable, inject } from '@angular/core';
import { Language, TranslateService } from '@ngx-translate/core';
import { StoredStateHelper } from './stored-state.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { setDayjsLocale } from '../dayjs-config';

@Injectable({
  providedIn: 'root'
})
export class AppTranslateService {
  private translate = inject(TranslateService);
  private stateHelper = inject(StoredStateHelper);
  
  private languageChangeSubject = new BehaviorSubject<string>('ru');

  constructor() {
    this.translate.setFallbackLang('ru');
    this.translate.use(localStorage.getItem('selectedLanguage') as Language);
    
    this.translate.onLangChange.subscribe(event => {
      this.languageChangeSubject.next(event.lang);
      
      setDayjsLocale(event.lang);
    });
    
    this.initializeLanguage();
  }

  /**
   * Переключить язык
   */
  switchLanguage(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('selectedLanguage', lang);    
    this.stateHelper.setAppLang(lang)
  }

  /**
   * Получить текущий язык
   */
  getCurrentLanguage(): string {
    return this.translate.getCurrentLang() || 'ru';
  }

  /**
   * Инициализировать язык из localStorage
   */
  initializeLanguage(): void {
    const savedLang = localStorage.getItem('selectedLanguage');
    if (savedLang && ['ru', 'en'].includes(savedLang)) {
      this.translate.use(savedLang);
      setDayjsLocale(savedLang);
    } else {
      this.translate.use('ru');
      setDayjsLocale('ru');
    }
  }

  /**
   * Получить перевод
   */
  get(key: string, params?: any): string {
    return this.translate.instant(key, params);
  }

  /**
   * Получить перевод как Observable
   */
  get$(key: string, params?: any) {
    return this.translate.get(key, params);
  }

  /**
   * Получить Observable для перевода, который обновляется при смене языка
   */
  getTranslation$(key: string, params?: any): Observable<string> {
    return this.languageChangeSubject.pipe(
      switchMap(() => this.translate.get(key, params))
    );
  }

  /**
   * Получить Observable для отслеживания смены языка
   */
  get languageChange$(): Observable<string> {
    return this.languageChangeSubject.asObservable();
  }
}